module.exports = __webpack_public_path__ + "img/noneData.png";